/** @jsx jsx */
import { css } from '@emotion/core';
import { FC } from 'react';
import { graphql } from 'gatsby';
import { Box, Text as RebassText } from 'rebass';
import MainContainer from '../../ui-components/container/container';
import { jsx } from 'theme-ui';
import { LinkProps } from '../../ui-components/link/link';
import Links from '../links/links';

import { processMarkdown } from '../../utils/utils.js';

interface Props {
  className?: string;
  id?: string;
  data: {
    id?: string;
    text: {
      text: string;
    };
    textBackground: 'White' | 'Fuschia' | 'Teal' | 'Purple' | 'Mustard';
    links: LinkProps[];
  };
  child?: boolean;
  css?: any;
}

export const query = graphql`
  fragment TextSection on ContentfulTextSection {
    id
    text {
      text
    }
    links {
      ...Links
    }
    textBackground: backgroundColor
    internal {
      type
    }
  }
`;

const Text: FC<Props & JSX.IntrinsicElements['div']> = ({
  className = '',
  data,
  child,
  ...rest
}) => {
  const {
    text: { text },
    textBackground,
    links
  } = data;

  let computedBackgroundColor;
  let computedTextColor;

  if (textBackground === 'White') {
    computedBackgroundColor = 'background';
    computedTextColor = 'text';
  } else if (textBackground === 'Fuschia') {
    computedBackgroundColor = 'fuschia';
    computedTextColor = 'background';
  } else if (textBackground === 'Purple') {
    computedBackgroundColor = 'purple';
    computedTextColor = 'background';
  } else if (textBackground === 'Teal') {
    computedBackgroundColor = 'primary';
    computedTextColor = 'text';
  } else {
    computedBackgroundColor = 'mustard';
    computedTextColor = 'text';
  }

  return (
    <Box bg={computedBackgroundColor}>
      <MainContainer css={{ paddingTop: child ? '0 !important' : '', paddingBottom: child ? '0 !important' : '' }}>
        <Box width="100%" flex="0 1 100%" maxWidth="100%">
          <RebassText
            dangerouslySetInnerHTML={{ __html: processMarkdown(text)}}
            sx={{ color: computedTextColor }}
            className="text-section"
          />
          {links && links.length > 0 && <Links links={links} />}
        </Box>
      </MainContainer>
    </Box>
  );
};

export default Text;
